import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';

class BrowseSharedRowRender extends Component {
  render = () => (
    <div
      onMouseDown={() => this.props.handleRowMouseDown(this.props)}
    >
      <ReactDataGrid.Row
        ref={c => {
          this.row = c;
        }}
        {...this.props}
      />
    </div>
  );
}

BrowseSharedRowRender.propTypes = {
  handleRowMouseDown: PropTypes.func,
};

export default BrowseSharedRowRender;
